<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Permissions Dashboard</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <h4>My User Name: {{user.loginName}}</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <h4>My Purchase Authority:</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 col-xs-12">
      {{user.tenantShortName}} Funds:&nbsp;{{ user.companyPurchaseAuth || 0 | currency:'USD':'symbol':'1.2-2'  }}
    </div>
    <div class="col-lg-4 col-xs-12">
      O&amp;A Funds:&nbsp;{{ user.oapurchaseAuth || 0 | currency:'USD':'symbol':'1.2-2' }}
    </div>
    <div class="col-lg-4 col-xs-12">
      Govt Funds:&nbsp;{{ user.govtPurchaseAuth || 0 | currency:'USD':'symbol':'1.2-2'}}
    </div>
  </div>
  <hr/>
  <div class="row">
    <div class="col-xs-12">
      <h4>My Permissions:</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <form novalidate #permGrid="ngForm" *ngIf="(dashboard|async) != null">
        <div>
          <aims-common-table
            id="PermissionsDashboard"
            [dataSource]="dashboardDataSource"
            [header]="dashboardColumns"
            [permissions]="permissions"
            [stickyHeader]="true"
            [pageSize]="10"
          >
          <aims-common-table-dynamic-row id="componentId">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              <div>
                {{ element.componentId | getText:'componentId':'component':components }}
              </div>
            </ng-template>
          </aims-common-table-dynamic-row>

          <!--Create-->
          <aims-common-table-dynamic-row id="createProvider">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                  {{ (element.createProvider == null && element.create) ? 'User' : element.createProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
            </ng-template>
          </aims-common-table-dynamic-row>
          <aims-common-table-dynamic-row id="create">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              <div class="text-center">
                <ng-container *ngIf="element.create === true">
                  <img src="{{imgSrc}}/check.png" style="width:20px" />
                </ng-container>
                <ng-container *ngIf="!element.create">
                  <img src="{{imgSrc}}/X.png" style="width:20px" />
                </ng-container>
              </div>
            </ng-template >
          </aims-common-table-dynamic-row>

          <!--Read-->
          <aims-common-table-dynamic-row id="readProvider">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              {{ (element.readProvider == null && element.read) ? 'User' : element.readProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="read">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                <div class="fullWidth text-center">
                  <ng-container *ngIf="element.read">
                    <img src="{{imgSrc}}/check.png" style="width:20px" />
                  </ng-container>
                  <ng-container *ngIf="!element.read">
                    <img src="{{imgSrc}}/X.png" style="width:20px" />
                  </ng-container>
                </div>
            </ng-template>
          </aims-common-table-dynamic-row>

          <!--Update-->
          <aims-common-table-dynamic-row id="updateProvider">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              {{ (element.updateProvider == null && element.update) ? 'User' : element.updateProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="update">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              <div class="fullWidth text-center">
                <ng-container *ngIf="element.update">
                  <img src="{{imgSrc}}/check.png" style="width:20px" />
                </ng-container>
                <ng-container *ngIf="!element.update">
                  <img src="{{imgSrc}}/X.png" style="width:20px" />
                </ng-container>
              </div>
            </ng-template>
          </aims-common-table-dynamic-row>

          <!--Delete-->
          <aims-common-table-dynamic-row id="deleteProvider">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                {{ (element.deleteProvider == null && element.delete) ? 'User' : element.deleteProvider | getText:'permissionGroupId':'permissionGroupName':groupValues }}
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="delete">
            <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
              <div class="fullWidth text-center">
                <ng-container *ngIf="element.delete">
                  <img src="{{imgSrc}}/check.png" style="width:20px" />
                </ng-container>
                <ng-container *ngIf="!element.delete">
                  <img src="{{imgSrc}}/X.png" style="width:20px" />
                </ng-container>
              </div>
            </ng-template>
          </aims-common-table-dynamic-row>
        </aims-common-table>
      </div>
    </form>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
